<template>
  <footer class="app-footer">
    <div class="app-footer__inner">
      <p class="app-footer__text">© {{ currentYear }} Suivi Depenses</p>
      <p class="app-footer__text app-footer__text--muted">Tableau de bord financier</p>
    </div>
  </footer>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.app-footer {
  margin-top: 0.75rem;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.85), rgba(241, 245, 249, 0.95));
}

.app-footer__inner {
  min-height: 44px;
  padding: 0.65rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.app-footer__text {
  margin: 0;
  font-size: 0.77rem;
  line-height: 1.2;
  color: #334155;
  font-weight: 600;
}

.app-footer__text--muted {
  color: #64748b;
  font-weight: 500;
}

@media (max-width: 640px) {
  .app-footer__inner {
    min-height: 40px;
    padding: 0.55rem 0.75rem;
    justify-content: center;
  }

  .app-footer__text {
    font-size: 0.72rem;
  }
}
</style>
